// Formatting helpers - British/Nigerian English, NGN, DD MMM YYYY, 24h WAT

export const formatNGN = (amount, opts = {}) => {
  if (amount == null || isNaN(amount)) return "—";
  const fixed = opts.short ? _short(amount) : amount.toLocaleString("en-NG", { maximumFractionDigits: opts.decimals || 0 });
  return `₦${fixed}`;
};

export const formatCurrency = (amount, currency = "NGN", opts = {}) => {
  if (amount == null || isNaN(amount)) return "—";
  if (currency === "NGN") return formatNGN(amount, opts);
  const fixed = opts.short ? _short(amount) : amount.toLocaleString("en-US", { maximumFractionDigits: opts.decimals || 0 });
  return `${currency} ${fixed}`;
};

const _short = (n) => {
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + "B";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return String(n);
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${dd} ${MONTHS[d.getMonth()]} ${d.getFullYear()} ${hh}:${mm} WAT`;
};

export const formatRelative = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "moments ago";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`;
  return `${Math.floor(diff / 86400)} d ago`;
};

export const maskBVN = (bvn) => (bvn ? `••• ••• ${bvn.slice(-4)}` : "—");
